import { fromJS, List, Map } from '@gonfalon/immutable-shim/immutableShim';

import type { CustomPropertyForm } from '#utils/flags/records/CustomPropertyForm';
import { createCustomPropertyForm } from '#utils/flags/records/CustomPropertyForm';

type CustomProperty = Map<string>;

export function customPropertiesToForm(customProperties?: Map<string, CustomProperty>) {
  return customProperties
    ? customProperties.reduce(
        // (lookup, val, key) => lookup.push(val ? val.set('key', key) : key),
        // toJS because we're going from the custom property API rep to our FE form rep thing
        (lookup, val, key) => lookup.push(createCustomPropertyForm(val.set('key', key).toJS())),
        List<CustomPropertyForm>(),
      )
    : List<CustomPropertyForm>();
}

export function addNewCustomProperty(customProperty: List<CustomPropertyForm>) {
  return customProperty.push(createCustomPropertyForm({ new: true }));
}

export function customPropertiesFormToRep(customPropertiesList: List<CustomPropertyForm>) {
  return customPropertiesList.reduce(
    // CHEAT: fromJS + toJS here are to brute-force convert a CustomPropertyForm to a CustomProperty rep for the API
    (lookup, val) => lookup.set(val.get('key'), fromJS(val.remove('key').toJS())),
    Map<string, CustomProperty>(),
  );
}
